import React from 'react'
import PaymentsDetailsView from './views/PaymentsDetailsView'
import usePaymentDetails from "./hooks/paymentDetails.hook";
import LandingLayout from "../include/landingLayout";

const PaymentDetails = (props) => {
    const paymentDetailsHook = usePaymentDetails()
    return (
        <LandingLayout>
            <PaymentsDetailsView {...paymentDetailsHook} />
        </LandingLayout>
    )
}

export default PaymentDetails